import React, { useEffect, useState, useRef } from "react";
import { api } from "../../../services/api";
import useUbicaciones from "../../../hooks/hookUbicacion";
import {
  CloseOutlined,
  ErrorOutlineOutlined,
  Add,
  Clear,
  Check,
} from "@mui/icons-material";
import {
  Alert,
  FormControl,
  TextField,
  Button,
  IconButton,
  Chip,
} from "@mui/material";

const DateSection = ({ error, onFechasChange, onUbicacionChange }) => {
  const refSeccion = useRef({});
  const [expandedSection, setExpandedSection] = useState(false);
  const [direccion, setDireccion] = useState("");
  const [mapUrl, setMapUrl] = useState("");

  const {
    provincias,
    ciudades,
    provSeleccionada,
    setProvSeleccionada,
    ciudadSeleccionada,
    setCiudadSeleccionada,
  } = useUbicaciones("AR"); // pais predefinido

  const mapdireccion =
    direccion + " " + ciudadSeleccionada + " " + provSeleccionada;

  useEffect(() => {
    const fetchMapData = async () => {
      if (mapdireccion && mapdireccion.trim() !== " ") {
        try {
          const response = await api.maps.getEmbedURL(mapdireccion);

          if (response.status === "success") {
            setMapUrl(response.embedUrl);
          } else {
            console.error("Error al obtener el mapa:", response.message);
          }
        } catch (error) {
          console.error("Error al obtener el mapa:", error);
        }
      }
    };

    fetchMapData();
  }, [mapdireccion]);
  useEffect(() => {
    if (onUbicacionChange) {
      onUbicacionChange({
        provincia: provSeleccionada,
        ciudad: ciudadSeleccionada,
        direccion: direccion,
        direccionCompleta: mapdireccion,
        mapUrl: mapUrl,
      });
    }
  }, [
    provSeleccionada,
    ciudadSeleccionada,
    direccion,
    mapUrl,
    onUbicacionChange,
    mapdireccion,
  ]);

  const handleSectionClick = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  //Manejo de fecha/s del evento
  const [variosDias, setVariosDias] = useState(false);
  const [fechas, setFechas] = useState([
    { fecha: "", hora_inicio: "", hora_fin: "", acceso_inicio: "" },
  ]);

  useEffect(() => {
    if (onFechasChange) {
      onFechasChange({
        variosDias,
        fechas,
      });
    }
  }, [variosDias, fechas, onFechasChange]);

  const handleVariosDiasChange = (valor) => {
    setVariosDias(valor);
    if (!valor) {
      setFechas([{ fecha: "", hora_inicio: "", hora_fin: "", acceso_inicio: "" }]);
    }
  };

  const handleFechaChange = (index, field, value) => {
    const nuevasFechas = [...fechas];
    nuevasFechas[index][field] = value;
    setFechas(nuevasFechas);
  };

  const agregarFecha = () => {
    setFechas([...fechas, { fecha: "", hora_inicio: "", hora_fin: "", acceso_inicio: "" }]);
  };

  const eliminarFecha = (index) => {
    if (fechas.length > 1) {
      const nuevasFechas = fechas.filter((_, i) => i !== index);
      setFechas(nuevasFechas);
    }
  };

  const handleProvChange = (event) => {
    const selectedProvIso2 = event.target.value;
    setProvSeleccionada(selectedProvIso2);
  };

  const handleCityChange = (event) => {
    const selectedCityId = event.target.value;
    setCiudadSeleccionada(selectedCityId);
  };

  return (
    <>
      <div
        ref={(el) => (refSeccion.current["date"] = el)}
        className={`seccion-evento ${expandedSection === "date" ? "expanded" : ""
          }`}
        onClick={() => handleSectionClick("date")}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex justify-content-between align-items-center gap-3">
            <p
              className={`titulo-seccion-evento ${expandedSection === "date" ? "hidden" : ""
                }`}
            >
              Fecha y ubicación
            </p>
            <Chip
              className={`${expandedSection === "date" ? "hidden" : ""}`}
              icon={<Check sx={{ color: "#5656FF !important" }} />}
              size="small"
              label="Requerido"
              sx={{ backgroundColor: "#E6E6FF", color: "#5656FF" }}
            />
          </div>

          {(error.fecha || error.hora || error.direccion) && (
            <ErrorOutlineOutlined
              sx={{
                color: "red",
                display: expandedSection === "date" ? "none" : "block",
              }}
            />
          )}
        </div>
        <p
          className={`descrip-seccion-evento ${expandedSection === "date" ? "hidden" : ""
            }`}
        >
          Proporciona la fecha, la hora y el lugar del evento para que los
          asistentes tengan toda la información necesaria para asistir.
        </p>

        {expandedSection === "date" && (
          <div className="contenido-evento" onClick={handleInputClick}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <p className="subtitulo-seccion-evento-expanded d-flex justify-content-start">
                Fecha y hora <span className="text-danger">*</span>
              </p>
              <button
                type="button"
                onClick={() => handleSectionClick("date")}
                className="d-flex justify-content-end"
              >
                <CloseOutlined sx={{ color: "#3659E3" }} />
              </button>
            </div>

            <div className="d-flex flex-wrap flex-row gap-3">
              <button
                type="button"
                onClick={() => handleVariosDiasChange(false)}
                className={`mr-2 mb-2 ${variosDias === false ? "boton-tipo-active" : "boton-tipo"
                  }`}
              >
                <div className="d-flex flex-column">
                  <span className="text-left">Una sola fecha</span>
                  <span className="descripcion-boton">
                    Evento que dura solo un día
                  </span>
                </div>
                <span className="indicator-wrapper">
                  <span className="indicator-fuera"></span>
                  <span className="indicator-dentro"></span>
                </span>
              </button>
              <button
                type="button"
                onClick={() => handleVariosDiasChange(true)}
                className={`mr-2 mb-2 ${variosDias === true ? "boton-tipo-active" : "boton-tipo"
                  }`}
              >
                <div className="d-flex flex-column">
                  <span className="text-left">Varias Fechas</span>
                  <span className="descripcion-boton text-left">
                    Eventos de varios días
                  </span>
                </div>
                <span className="indicator-wrapper">
                  <span className="indicator-fuera"></span>
                  <span className="indicator-dentro"></span>
                </span>
              </button>
            </div>
            <div className="date-hora">
              {variosDias === false ? (
                // Sola fecha
                <div className="data-hora-form">
                  <div className="d-flex gap-4 mt-3 mb-3 flex-wrap">
                    <FormControl>
                      <small>Fecha</small>
                      <TextField
                        type="date"
                        value={fechas[0]?.fecha}
                        onChange={(e) =>
                          handleFechaChange(0, "fecha", e.target.value)
                        }
                        required
                        size="small"
                      />
                    </FormControl>
                    <FormControl>
                      <small>Hora de inicio</small>
                      <TextField
                        type="time"
                        value={fechas[0]?.hora_inicio}
                        onChange={(e) =>
                          handleFechaChange(0, "hora_inicio", e.target.value)
                        }
                        required
                        size="small"
                      />
                    </FormControl>
                    <FormControl>
                      <small>Hora de finalización</small>
                      <TextField
                        type="time"
                        value={fechas[0]?.hora_fin}
                        onChange={(e) =>
                          handleFechaChange(0, "hora_fin", e.target.value)
                        }
                        required
                        size="small"
                      />
                    </FormControl>
                  </div>

                  <div className="d-flex gap-4 mt-1">
                    <FormControl>
                      <small>Hora de inicio de acceso</small>
                      <small>¿Desde qué hora querés empezar a escanear tickets?</small>
                      <TextField
                        type="time"
                        value={fechas[0]?.acceso_inicio}
                        onChange={(e) =>
                          handleFechaChange(0, "acceso_inicio", e.target.value)
                        }
                        required
                        size="small"
                      />
                    </FormControl>
                  </div>
                </div>
              ) : (
                // Múltiples fechas
                <>
                  <div>
                    {fechas.map((item, index) => (
                      <React.Fragment key={index}>
                        <div className="d-flex gap-4 mt-3 flex-wrap">
                          <FormControl>
                            <small>Fecha</small>
                            <TextField
                              type="date"
                              value={item.fecha}
                              onChange={(e) =>
                                handleFechaChange(index, "fecha", e.target.value)
                              }
                              required
                              size="small"
                            />
                          </FormControl>
                          <FormControl>
                            <small>Hora de inicio</small>
                            <TextField
                              type="time"
                              value={item.hora_inicio}
                              onChange={(e) =>
                                handleFechaChange(
                                  index,
                                  "hora_inicio",
                                  e.target.value
                                )
                              }
                              required
                              size="small"
                            />
                          </FormControl>
                          <FormControl>
                            <small>Hora de finalización</small>
                            <TextField
                              type="time"
                              value={item.hora_fin}
                              onChange={(e) =>
                                handleFechaChange(
                                  index,
                                  "hora_fin",
                                  e.target.value
                                )
                              }
                              required
                              size="small"
                            />
                          </FormControl>
                          {fechas.length > 1 && (
                            <IconButton
                              color="error"
                              onClick={() => eliminarFecha(index)}
                            >
                              <Clear />
                            </IconButton>
                          )}
                        </div>

                        <div className="d-flex gap-4 mt-1 mb-3">
                          <FormControl>
                            <small>Hora de inicio de acceso</small>
                            <small>¿Desde qué hora querés empezar a escanear tickets?</small>
                            <TextField
                              type="time"
                              value={item.acceso_inicio}
                              onChange={(e) =>
                                handleFechaChange(
                                  index,
                                  "acceso_inicio",
                                  e.target.value
                                )
                              }
                              required
                              size="small"
                            />
                          </FormControl>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                  <Button
                    variant="text"
                    startIcon={<Add />}
                    onClick={agregarFecha}
                    sx={{ marginTop: "10px" }}
                  >
                    Agregar Fecha
                  </Button>
                </>
              )}
            </div>

            <FormControl>
              <p className="subtitulo-seccion-evento-expanded mt-2 ">
                Ubicacion <span className="text-danger">*</span>
              </p>
              <p className="descrip-seccion-evento-expanded">
                Agrega la dirección o el lugar donde se llevará a cabo tu evento
              </p>
              <div className="d-flex flex-wrap gap-1 align-items-center">
                <FormControl onClick={handleInputClick} className="" style={{}}>
                  <div>
                    <select
                      value={provSeleccionada}
                      onChange={handleProvChange}
                      required
                      style={{}}
                      className="input-select-evento"
                    >
                      <option value="">Seleccione una provincia</option>
                      {provincias.map((provincia) => (
                        <option key={provincia.iso2} value={provincia.iso2}>
                          {provincia.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </FormControl>
                <FormControl onClick={handleInputClick} className="">
                  <div>
                    <select
                      value={ciudadSeleccionada}
                      onChange={handleCityChange}
                      required
                      className="input-select-evento"
                      disabled={!provSeleccionada}
                    >
                      <option value="" disabled>
                        Seleccione una ciudad
                      </option>
                      {ciudades.map((ciudad) => (
                        <option key={ciudad.id} value={ciudad.name}>
                          {ciudad.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </FormControl>
                <FormControl
                  onClick={handleInputClick}
                  className=""
                  style={{ width: "60%" }}
                >
                  <TextField
                    sx={{
                      marginTop: "5px",
                      marginBottom: "15px",
                      input: {
                        padding: "10px 15px",
                      },
                    }}
                    name="direccion"
                    placeholder="Direccion"
                    onClick={handleInputClick}
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
                    required
                  />
                </FormControl>
              </div>
              <>
                {error.direccion && (
                  <Alert severity="error">{error.direccion}</Alert>
                )}
              </>
              <div className="d-flex justify-content-center mt-3">
                <iframe
                  title={`Mapa de ${direccion}, ${ciudadSeleccionada}`}
                  className="rounded shadow"
                  width="100%"
                  height="230"
                  id="map"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src={mapUrl}
                ></iframe>
              </div>
            </FormControl>
          </div>
        )}
      </div>
    </>
  );
};

export default DateSection;
